export const SET_IS_FOOD_TICKETS = 'foodTickets/SET_IS_FOOD_TICKETS';
export const SET_FOOD_TICKETS_DATA = 'foodTickets/SET_FOOD_TICKETS_DATA';
